import script from "./diningRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./diningRecords.vue?vue&type=script&setup=true&lang=js"

import "./diningRecords.vue?vue&type=style&index=0&id=651e789c&lang=scss"

const __exports__ = script;

export default __exports__